import React, { useState, useEffect, useRef } from 'react';
import PageBox from '../../components/PageBox';
import AboutMenu from '../../components/AboutMenu';
import AboutTitle from '../../components/AboutTitle';
import './index.less';
import huoban1 from "../../static/images/huoban1.png";
import huoban2 from "../../static/images/huoban2.png";
import huoban3 from "../../static/images/huoban3.png";
import huoban4 from "../../static/images/huoban4.png";

export default function App() {
  // 定义状态
  const [isPaused, setIsPaused] = useState(false);
  const [scrollSpeed, setScrollSpeed] = useState(1); // 滚动速度，默认为1px/30ms
  
  // 创建引用
  const scrollContainerRef = useRef(null);
  const intervalRef = useRef(null);
  
  // 滚动项数据
  const scrollItems = [
    { id: 1, img: huoban1,  },
    { id: 2, img: huoban2, },
    { id: 3, img: huoban3,  },
    { id: 2, img: huoban2, },
    { id: 1, img: huoban1,  },
    { id: 4, img: huoban4,},
    { id: 5, img: huoban2, },
    { id: 3, img: huoban3,  },
  ];
  
  // 初始化滚动效果
  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    
    if (scrollContainer) {
      const scrollContent = scrollContainer.querySelector('ul');
      
      // 复制内容以实现无缝滚动
      const scrollContentClone = scrollContent.cloneNode(true);
      scrollContentClone.id = 'scrollContentClone';
      scrollContainer.appendChild(scrollContentClone);
      
      // 设置初始滚动位置
      let scrollPosition = 0;
      // 定义滚动函数
      const scroll = () => {
        if (!isPaused) {
          scrollPosition += scrollSpeed;
          
          // 检查是否需要重置滚动位置
          if (scrollPosition >= scrollContent.offsetWidth) {
            scrollPosition = 0;
          }
          // 应用滚动位置
          scrollContent.style.transform = `translateX(-${scrollPosition}px)`;
          scrollContentClone.style.transform = `translateX(-${scrollPosition}px)`;
        }
      };
      
      // 设置定时器
      intervalRef.current = setInterval(scroll, 30);
      
      // 清理函数
      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }
      };
    }
  }, []);
  
  // 当isPaused或scrollSpeed改变时更新滚动状态
  useEffect(() => {
    // 不需要额外操作，因为滚动函数会检查isPaused状态
  }, [isPaused, scrollSpeed]);
  
  
  return (
    <>
      <PageBox useBanner={true}>
        <div className='aboutBanner'></div>
        <AboutMenu active={'4'} />
        <AboutTitle name={'合作与服务'} english={'PARTNER'} />
        
        {/* 滚动容器 */}
        <div ref={scrollContainerRef} className='propertyList'>
          <ul>
            {scrollItems.map(item => (
              <li key={item.id}>
                <img src={item.img} alt={item.alt}/>
              </li>
            ))}
          </ul>
        </div>
        
      </PageBox>
    </>
  );
}
